/** API response shape for organization-manager dashboard stats.
 * Swap the service implementation when the real endpoint exists — keep this contract stable.
 */

export type AccountabilitySiteStatus = 'breach' | 'warning' | 'compliant';

export type BusinessImpact = 'critical' | 'warning' | 'good';

export type RepairQuarterCode = 'Q1' | 'Q2' | 'Q3' | 'Q4';

/** Reporting window for the executive dashboard. Passed to the stats API when it exists. */
export type DashboardPeriod =
  | 'q1-2026'
  | 'q2-2026'
  | 'q3-2026'
  | 'q4-2026'
  | 'last-12-months';

export const DASHBOARD_PERIODS: readonly DashboardPeriod[] = [
  'q1-2026',
  'q2-2026',
  'q3-2026',
  'q4-2026',
  'last-12-months',
] as const;

export type SessionSuccessKpiDto = {
  ratePercent: number;
  targetPercent: number;
};

export type TopDropOffCausesKpiDto = {
  primaryRank: number;
  secondaryRank: number;
  primaryCause: string;
  secondaryCause: string;
  causesTracked: number;
  progressPercent: number;
};

export type AccountabilitySiteDto = {
  id: string;
  siteName: string;
  status: AccountabilitySiteStatus;
  hoursLate: number | null;
  penaltyEuros: number | null;
};

export type AccountabilityDto = {
  activeBreaches: number;
  penaltiesTotalEuros: number;
  slaComplianceRatePercent: number;
  compliantSites: number;
  totalSites: number;
  sites: AccountabilitySiteDto[];
};

export type RepairQuarterDto = {
  quarter: RepairQuarterCode;
  hours: number;
  highlighted: boolean;
};

export type RepairHoursDto = {
  targetHours: number;
  peakHours: number;
  currentHours: number;
  quarters: RepairQuarterDto[];
};

export type PortfolioSiteDto = {
  id: string;
  location: string;
  chargersRating: number;
  chargersRatingMax: number;
  ownershipIssue: string;
  contractStatus: string;
  businessImpact: BusinessImpact;
};

export type OrganizationManagerDashboardStatsDto = {
  siteCount: number;
  chargerCount: number;
  lastUpdatedAt: string;
  sessionSuccess: SessionSuccessKpiDto;
  topDropOffCauses: TopDropOffCausesKpiDto;
  accountability: AccountabilityDto;
  repairHours: RepairHoursDto;
  portfolio: PortfolioSiteDto[];
};
